import { OKTA_CLIENT_ID, OKTA_ISSUER} from "../services/Constants";

const REDIRECT_URI = `${window.location.origin}/login/callback`;

export default {
  oidc: {
    clientId: OKTA_CLIENT_ID,
    issuer: OKTA_ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    responseType: ['id_token', 'token']
  }
};